import { Box, Switch, CircularProgress, FormHelperText, Backdrop, Typography } from "@mui/material";
import {
  SectionTitle,
  StyledOneChildContainer,
  StyledParentContainer,
  StyledTwoChildContainer,
} from "../../StyledComponents/Container";
import { StyledInputLabel } from "../../StyledComponents/InputLabel";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getLoanDatesByLoanId,
  getLoanNumberByPId,
  getSourceList,
} from "../../services/AutoDebit/AutoDebitServices";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import * as constants from "../../../../constants";
import CancelPopUp from "../../../PopUp/PopUp";
import { useTranslation } from "react-i18next";
import ContainedButton from "../../../../shared/Button/CustomContainedButton";
import OutlinedButton from "../../../../shared/Button/customOutlinedButton";
import Grid from "@mui/material/Grid2";
import CustomAutocomplete from "../../../../shared/AutoComplete";
import CustomTextField from "../../../../shared/CustomTextFeild";
import CustomDatePicker from "../../../../shared/CustomDate";
import { notifyUser } from "../../Utils/notifyUser";

//   2043-05-01T08:00:00.000Z to  2043-05-01
const formatConvertDate = (timestamp: string): string => {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed, so we add 1
  const day = String(date.getDate()).padStart(2, "0"); // Pad day with leading zero if needed

  return `${year}-${month}-${day}`;
};

const formatDate = (dateString: string): string => {
  if (!dateString) return "-";

  const [year, month, day] = dateString.split("-").map(Number);
  const date = new Date(year, month - 1, day);

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

function formatToYYYYMMDD(dateTimeString: any) {
  const date = new Date(dateTimeString);
  // Check if date is valid
  if (isNaN(date.getTime())) {
    return "Invalid date";
  }
  return date.toISOString().slice(0, 10);
}
const convertDate = (dateString: string): string => {
  const utcDate = new Date(dateString);
  if (isNaN(utcDate.getTime())) return "";

  const localDate = new Date(
    utcDate.getUTCFullYear(),
    utcDate.getUTCMonth(),
    utcDate.getUTCDate()
  );
  const month = (localDate.getMonth() + 1).toString().padStart(2, "0");
  const day = localDate.getDate().toString().padStart(2, "0");
  const year = localDate.getFullYear();

  return `${month}/${day}/${year}`;
};
function convertToDateOnly(datetimeString: any) {
  // Example input: "2025-07-01T08:00"
  const date = new Date(datetimeString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`; // "2025-07-01"
}

const convertDateYYY_MM_DD = (dateString: any) => {
  const [month, day, year] = dateString.split("/");
  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
};

function formatCurrency(amount: any) {
  return amount?.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function convertToISOString(inputDate: string): string {
  const [year, month, day] = inputDate.split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day, 8, 0, 0)); // 8:00 AM UTC
  return date.toISOString();
}

const AutoDebitLoanDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formData = location.state;
  const userInfo = useSelector((state: RootState) => state.auth);
  const { t } = useTranslation();
  const translate = t as (key: string) => string;

  const [loanNumber, setLoanNumber] = useState<any>(null);
  const [source, setSource] = useState<any>("");
  const [description, setDescription] = useState<any>("");
  const [isRecurring, setIsRecurring] = useState<boolean>(false);
  const [frequency, setFrequency] = useState<any>("");
  const [endDate, setEndDate] = useState<string>("");
  const [amount, setAmount] = useState<any>("");
  const [autoDebit, setAutoDebit] = useState<any>("");
  const [beginningDate, setBeginningDate] = useState<string>("");
  const [loanData, setLoanData] = useState<
    { loanId: number; loanNumber: string; loanDescription: string }[]
  >([]);
  const [beginningDates, setBeginningDates] = useState([]);
  const [sourceList, setSourceList] = useState<any>([]);
  const [fundId, setFundId] = useState(0);
  const [fundType, setFundType] = useState("");
  const [openPopUp, setOpenPopUp] = useState(false);
  const [blackdropFlag, setBlackdropFlag] = useState(false)
  const [autoDebitScheduleDetails, setAutoDebitScheduleDetails] = useState([]);
  const [autoDebitId, setAutoDebitId] = useState(0);
  const [version, setVersion] = useState(0);

  const [errors, setErrors] = useState({
    loanNumber: "",
    source: "",
    amount: "",
    autoDebit: "",
    beginningDate: "",
    frequency: "",
    endDate: "",
  });

  const handleLoanNumberChange = (event: any, newValue: any) => {
    if (newValue) {
      setLoanNumber(newValue);
      setDescription(newValue?.loanDescription);
      setBeginningDate("");
      setErrors((prev) => ({ ...prev, loanNumber: "" }));
    } else {
      setLoanNumber("");
    }
  };
  const handleSourceChange = (event: any, newValue: any) => {
    if (newValue) {
      setSource(newValue);
      setFundId(newValue?.fundId);
      setFundType(
        newValue.fundName === "Checking" ? newValue.fundName : newValue.fundType
      );
      setErrors((prev) => ({ ...prev, source: "" }));
    } else {
      setSource("");
    }
  };
  const handleRecurringChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsRecurring(event.target.checked);
    if (!event.target.checked) {
      setEndDate("");
      setFrequency("");
    }
  };
  const handleFrequencyChange = (event: any, newValue: any) => {
    setFrequency(newValue);
    if (newValue != null && newValue.value != "onlyTill") {
      setEndDate("");
      setErrors((prev) => ({ ...prev, endDate: "" }));
    }
    setErrors((prev) => ({ ...prev, frequency: "" }));
  };
  const handleAmountChange = (event: any, newValue: any) => {
    setAmount(newValue);
    setErrors((prev) => ({ ...prev, amount: "" }));
  };
  const handleAutoDebitChange = (event: any, newValue: any) => {
    setAutoDebit(newValue);
    setErrors((prev) => ({ ...prev, autoDebit: "" }));
  };
  const handleBeginningDateChange = (event: any, newValue: any) => {
    setBeginningDate(newValue);
    setErrors((prev) => ({ ...prev, beginningDate: "" }));
  };
  const handleEndDateChange = (newValue: dayjs.Dayjs | null) => {
    if (newValue && dayjs(beginningDate).isAfter(newValue)) {
      setEndDate(newValue.format("YYYY-MM-DD"));
      setErrors((prev) => ({
        ...prev,
        endDate: translate("endDateCannotBeEarlierthanBeginningDate"),
      }));
    } else {
      setEndDate(newValue ? newValue.format("YYYY-MM-DD") : "");
      setErrors((prev) => ({ ...prev, endDate: "" }));
    }
  };
  const handleCancel = () => {
    setOpenPopUp(true);
  };
  const handlePopUpClose = () => {
    setOpenPopUp(false);
  };
  function handleConfirm() {
    navigate("/autoDebitListing");
  }

  const validateForm = () => {
    const newErrors = {
      loanNumber: loanNumber ? "" : translate("pleaseSelectLoan"),
      source: source ? "" : translate("pleaseSelectSource"),
      amount: amount ? "" : translate("amountIsRequired"),
      autoDebit: autoDebit ? "" : translate("pleaseSelectAutoDebit"),
      beginningDate: beginningDate
        ? ""
        : translate("pleaseSelectBeginningDate"),
      frequency:
        isRecurring && !frequency ? translate("frequencyIsRequired") : "",
      endDate:
        frequency != null && frequency?.value === "onlyTill" && !endDate
          ? translate("pleaseSelectEndDate")
          : beginningDate &&
            frequency?.value === "onlyTill" &&
            endDate &&
            dayjs(beginningDate).isAfter(dayjs(endDate))
            ? translate("endDateCannotBeEarlierthanBeginningDate")
            : "",
    };

    setErrors(newErrors);

    return !Object.values(newErrors).some((error) => error !== "");
  };

  const handleContinueClick = () => {
    const isValid = validateForm();
    if (isValid) {
      let finalEndDate = endDate;

      if (!isRecurring) {
        finalEndDate = beginningDate;
        setEndDate(finalEndDate);
      }

      if (isRecurring && frequency.value === "forTheLifeTimeOfLoan") {
        finalEndDate = beginningDates[beginningDates.length - 1];
        setEndDate(finalEndDate);
      }
      if (endDate) {
        finalEndDate = convertToISOString(endDate);
        setEndDate(finalEndDate);
      }
      const formData = {
        autoDebitId,
        loanNumber,
        source,
        description,
        isRecurring,
        frequency,
        endDate: finalEndDate,
        amount,
        autoDebit,
        beginningDate: convertDate(beginningDate),
        fundId,
        fundType,
        autoDebitScheduleDetails,
        version,
      };
      navigate("/autoDebitReviewAndSubmit", { state: formData });
    }
  };

  async function getLoanNumByPid(pId: number, clientId: number) {
    setBlackdropFlag(true);
    try {
      const response = await getLoanNumberByPId(pId, clientId);

      if (response.status === constants.STATUS_CODES.SUCCESS) {
        const loanDataArray = response.data.data;

        const formattedLoanData = loanDataArray.map((loan: any) => ({
          loanId: loan.loanId,
          loanNumber: loan.loanNumber,
          loanDescription: loan.description,
        }));
        setLoanData(formattedLoanData);
      } else {
        notifyUser(
          response.response.data.message,
          "error",
          translate("entertheAutoDebitLoandetails")
        );
      }
    } catch (error) {
      console.error("Error handling fund source:", error);
    } finally {
      setBlackdropFlag(false); // Stop loading after fetching
    }
  }
  async function getLoanSourceList(pId: number, clientId: number) {
    setBlackdropFlag(true);
    try {
      const response = await getSourceList(pId, clientId);

      if (response.status === constants.STATUS_CODES.SUCCESS) {
        const { cashAccounts, funds } = response.data.data;

        const cashAccountEntry = cashAccounts?.fundName
          ? {
            fundId: cashAccounts.fundId,
            fundName: cashAccounts.fundName,
            fundType: cashAccounts.fundType,
            description: cashAccounts.description,
            availableBalance: cashAccounts.availableBalance,
          }
          : null;

        const mappedFunds = funds.map((fund: any) => ({
          fundId: fund.fundId,
          fundName: fund.fundName,
          fundType: fund.fundType,
          description: fund.description,
          availableBalance: fund.availableBalance,
        }));

        // ✅ Build final list conditionally
        const finalSourceList = [
          ...(cashAccountEntry ? [cashAccountEntry] : []),
          ...mappedFunds,
        ];
        setSourceList(finalSourceList);
      } else {
        notifyUser(
          response.response?.data?.message || translate("failedToFetchFundSources"), "error", translate("loandetails")
        );
      }
    } catch (error: any) {
      notifyUser(
        error.response?.data?.message || translate("failedToFetchFundSources"), "error", translate("loandetails")
      );
    } finally {
      setBlackdropFlag(false);
    }
  }
  async function getLoanDates(lId: number, clientId: number) {
    try {
      const response = await getLoanDatesByLoanId(lId, clientId);

      if (response.status === constants.STATUS_CODES.SUCCESS) {
        setBeginningDates(response.data.data);
      } else {
        notifyUser(
          response.response.data.message,
          "error",
          translate("entertheAutoDebitLoandetails")
        );
      }
    } catch (error) {
      console.error("Error handling dates:", error);
    }
  }

  useEffect(() => {
    getLoanNumByPid(userInfo.defaultParticipantId, userInfo.clientId);
    getLoanSourceList(userInfo.defaultParticipantId, userInfo.clientId);
  }, []);

  useEffect(() => {
    const frequencyOptions = [
      { label: "For the life of the loan", value: "forTheLifeTimeOfLoan" },
      { label: "Only till", value: "onlyTill" },
    ];
    const amountOptions = [
      { label: "Choose one...", value: "All" },
      { label: "Statement Due", value: "statementDue" },
    ];
    const autoDebitOptions = [
      { label: "On Due Date", value: "OnDueDate" },
      { label: "3 days before due date", value: "3daysBeforeDueDate" },
    ];
    const detailsData = location.state?.detailsData;
    if (detailsData && loanData.length > 0 && sourceList.length > 0) {
      setAutoDebitId(detailsData.id);
      const loan = loanData.find(
        (option) =>
          option.loanNumber ===
          (detailsData.loanNumber || formData.loanNumber.loanNumber)
      );
      setLoanNumber(loan);
      const source = sourceList.find(
        (option: { fundId: any }) => option.fundId === detailsData.entityId
      );
      setSource(source);
      setDescription(detailsData.loanDescription);

      setIsRecurring(detailsData.paymentRecurring == "Yes" ? true : false);
      const selectedFrequency = frequencyOptions.find(
        (option) => option.value === detailsData.frequency
      );
      setFrequency(selectedFrequency);
      const endDate =
        detailsData.paymentRecurring == "Yes" &&
          selectedFrequency?.value === "onlyTill"
          ? convertToDateOnly(detailsData.paymentEndingDate)
          : "";
      setEndDate(endDate);
      const selectedAmount = amountOptions.find(
        (option) => option.value === (detailsData.amount || formData.value)
      );
      setAmount(selectedAmount);
      const selectedautoDebit = autoDebitOptions.find(
        (option) => option.value === detailsData.autoDebitOption
      );
      setAutoDebit(selectedautoDebit);
      setBeginningDate(formatToYYYYMMDD(detailsData.paymentBeginningDate));
      setFundId(detailsData.entityId);
      setFundType(detailsData.entityType);
      setAutoDebitScheduleDetails(detailsData.autoDebitScheduleDetails);
      setVersion(detailsData.version);
    }
    const submitData = location.state?.submitData;
    if (submitData && loanData.length > 0 && sourceList.length > 0) {
      setAutoDebitId(submitData.autoDebitId);
      setLoanNumber(submitData.loanNumber);
      setSource(submitData.source);
      setDescription(submitData.description);
      setIsRecurring(submitData.isRecurring);
      setFrequency(submitData.frequency);
      setEndDate(formatConvertDate(submitData.endDate));
      setAmount(submitData.amount);
      setAutoDebit(submitData.autoDebit);
      setBeginningDate(convertDateYYY_MM_DD(submitData.beginningDate));
      setFundId(submitData.fundId);
      setFundType(submitData.fundType);
      setVersion(submitData.version);
    }
  }, [loanData, sourceList]);

  useEffect(() => {
    if (loanNumber != null && loanNumber.loanId > 0) {
      getLoanDates(loanNumber.loanId, userInfo.clientId);
    }
  }, [loanNumber]);

  return (
    <StyledParentContainer>
      <StyledOneChildContainer>
        <StyledTwoChildContainer sx={{ border: "none" }}>
          <SectionTitle>
            {translate("entertheAutoDebitLoandetails")}
          </SectionTitle>
          <StyledTwoChildContainer>
            <Box sx={{ width: "100%", padding: "40px" }}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }} direction={"column"}>
                  <Box sx={{ mb: 2 }}>
                    <CustomAutocomplete
                      labelText={translate("loanNumber")}
                      required
                      value={loanNumber || null}
                      onChange={handleLoanNumberChange}
                      options={loanData}
                      getOptionLabel={(option) =>
                        `${option.loanNumber} - ${option.loanDescription}`
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.loanId === value
                      }
                      placeholder="Select Loan Number"
                      error={!!errors.loanNumber}
                      disabled={autoDebitId != 0}
                    />
                    {errors.loanNumber && (
                      <FormHelperText error>
                        {errors.loanNumber}
                      </FormHelperText>
                    )}
                  </Box>
                  <Box>
                    <CustomAutocomplete
                      labelText={translate("source")}
                      required
                      value={source || null}
                      onChange={handleSourceChange}
                      options={sourceList}
                      getOptionLabel={(option) =>
                        `${option.fundName} - ${option.availableBalance}`
                      }
                      placeholder="Select Source"
                      error={!!errors.source}
                    />
                    {errors.source && (
                      <FormHelperText error>{errors.source}</FormHelperText>
                    )}
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }} alignItems="stretch">
                  <CustomTextField
                    labelText={translate("description")}
                    value={description}
                    multiline
                    rows={4.5}
                    readOnly={true}
                  />
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 0, lg: 4 }}
                  sx={{ display: { sm: "none", xs: "block", lg: "block" } }}
                ></Grid>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <StyledInputLabel shrink>
                    {translate("recurring")}
                  </StyledInputLabel>
                  <Switch
                    checked={isRecurring}
                    onChange={handleRecurringChange}
                  />
                </Grid>
                {isRecurring && (
                  <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                    <CustomAutocomplete
                      labelText={translate("frequency")}
                      value={frequency || null}
                      onChange={handleFrequencyChange}
                      options={[
                        {
                          label: "For the life of the loan",
                          value: "forTheLifeTimeOfLoan",
                        },
                        { label: "Only till", value: "onlyTill" },
                      ]}
                      placeholder="Select Frequency"
                      error={!!errors.frequency}
                    />
                    {errors.frequency && (
                      <FormHelperText error>
                        {errors.frequency}
                      </FormHelperText>
                    )}
                  </Grid>
                )}
                {isRecurring &&
                  frequency != null &&
                  frequency?.value != "onlyTill" && (
                    <Grid
                      size={{ xs: 12, sm: 0, lg: 4 }}
                      sx={{
                        display: { sm: "none", xs: "block", lg: "block" },
                      }}
                    ></Grid>
                  )}
                {isRecurring &&
                  frequency != null &&
                  frequency?.value == "onlyTill" && (
                    <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                      <CustomDatePicker
                        labelText={translate("endDate")}
                        value={endDate ? dayjs(endDate) : null}
                        onChange={handleEndDateChange}
                        error={!!errors.endDate}
                      />
                      {errors.endDate && (
                        <FormHelperText error>
                          {errors.endDate}
                        </FormHelperText>
                      )}
                    </Grid>
                  )}
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <CustomAutocomplete
                    labelText={translate("amount")}
                    required
                    value={amount || null}
                    onChange={handleAmountChange}
                    options={[
                      { label: "Statement Due", value: "statementDue" },
                    ]}
                    getOptionLabel={(option) => option.label}
                    placeholder="Select Amount"
                    error={!!errors.amount}
                  />
                  {errors.amount && (
                    <FormHelperText error>{errors.amount}</FormHelperText>
                  )}
                </Grid>
                {!isRecurring && (
                  <Grid
                    size={{ xs: 12, sm: 0, lg: 4 }}
                    sx={{ display: { sm: "none", xs: "block", lg: "block" } }}
                  ></Grid>
                )}
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <CustomAutocomplete
                    labelText={translate("autoDebit")}
                    required
                    value={autoDebit || null}
                    onChange={handleAutoDebitChange}
                    options={[
                      { label: "On Due Date", value: "OnDueDate" },
                      {
                        label: "3 days before due date",
                        value: "3daysBeforeDueDate",
                      },
                    ]}
                    getOptionLabel={(option) => option.label}
                    placeholder="Select Auto Debit"
                    error={!!errors.autoDebit}
                  />
                  {errors.autoDebit && (
                    <FormHelperText error>{errors.autoDebit}</FormHelperText>
                  )}
                </Grid>
                {isRecurring && (
                  <Grid
                    size={{ xs: 12, sm: 0, lg: 4 }}
                    sx={{ display: { sm: "none", xs: "block", lg: "block" } }}
                  ></Grid>
                )}
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <CustomAutocomplete
                    labelText={translate("beginningDate")}
                    required
                    value={beginningDate || null}
                    onChange={handleBeginningDateChange}
                    options={beginningDates}
                    getOptionLabel={(option) => formatDate(option)}
                    placeholder="Select Beginning Date"
                    error={!!errors.beginningDate}
                  />
                  {errors.beginningDate && (
                    <FormHelperText error>
                      {errors.beginningDate}
                    </FormHelperText>
                  )}
                </Grid>
              </Grid>
            </Box>
          </StyledTwoChildContainer>
          <div className="right-fields" style={{ marginTop: "10px" }}>
            <ContainedButton sx={{ mr: 2 }} onClick={handleContinueClick}>
              {" "}
              {translate("continue")}
            </ContainedButton>
            <OutlinedButton onClick={handleCancel}>
              {" "}
              {translate("cancel")}
            </OutlinedButton>
          </div>
          <CancelPopUp
            open={openPopUp}
            popupTitle={translate("confirmCancel")}
            handleClose={handlePopUpClose}
            saveChanges={() => handleConfirm()}
            message={translate("doYouWantToCancelChanges?")}
          />

          <Backdrop
            sx={(theme) => ({
              color: "#fff",
              zIndex: theme.zIndex.drawer + 1,
              display: "flex",
              flexDirection: "column",
            })}
            open={blackdropFlag}
          >
            <CircularProgress color="inherit" />
            <Typography color="white">Please wait...</Typography>
          </Backdrop>
        </StyledTwoChildContainer>
      </StyledOneChildContainer>
    </StyledParentContainer>
  );
};

export default AutoDebitLoanDetails;
